/**
 * Which way the records page shows its rows: each row, or each person.
 *
 * It opens on the rows, since that is what the page is called. People is a
 * menu item of its own, `/leads?view=people`, so the two menu items are the
 * switch: the address decides, and nothing is remembered, so Rows always
 * opens the rows and People the people.
 */
import { useSearchParams } from 'react-router-dom';

export type RecordsView = 'leads' | 'people';

export const isRecordsView = (v: unknown): v is RecordsView => v === 'leads' || v === 'people';

/**
 * The view to show. The URL wins, then the rows; and someone allowed only
 * one of the two gets that one.
 */
export function resolveView({
  param, canLeads, canPeople,
}: {
  param: string | null;
  canLeads: boolean;
  canPeople: boolean;
}): RecordsView {
  if (!canPeople) return 'leads';
  if (!canLeads) return 'people';
  return isRecordsView(param) ? param : 'leads';
}

/** The view the address asks for. */
export function useRecordsView(canLeads: boolean, canPeople: boolean): RecordsView {
  const [params] = useSearchParams();
  return resolveView({ param: params.get('view'), canLeads, canPeople });
}
